import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */


//获取题库详情

/* export const findTestsDetail = (id) => {
  return request('/tests/testsdetail', 'get', { id })
} */
/* 
//获取视频推荐
export const findVideoRecommand = (clID) => {
  return request('/video/recommend', 'get', { clID })
}



export const findVideoPlay = (id) => {
  return request('/video/play', 'get', { id })
} */

//获取read资料
export const findRead = ({ maID, chID, coID, clID, page, size }) => {
  return request('/read/readlist', 'get', { maID, chID, coID, clID, page, size })
}
